import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=8a670e02&scoped=true&"
import script from "./Renderer.vue?vue&type=script&lang=js&"
export * from "./Renderer.vue?vue&type=script&lang=js&"
import style0 from "./Renderer.vue?vue&type=style&index=0&id=8a670e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a670e02",
  null
  
)

export default component.exports